module.exports = __webpack_public_path__ + "media/images/services/po-66886c7cca765bda1de237769cc63c35.svg";